/* global justifiedLayout */

import $ from 'jquery';

export default function () {
  $(document).ready(function () {
    computeLayout();
  });

  $(window).resize(function () {
    computeLayout();
  });
}

function computeLayout() {
  let container =  $('.gallery');
  let ratios = container.data('ratios');

  let geometry = justifiedLayout(ratios, {
    containerWidth: container.width(),
    containerPadding: 0,
    boxSpacing: 10
  });

  container.height(geometry.containerHeight);

  $('.gallery .gallery-item').each(function (index, element) {
    $(element).height(geometry.boxes[index].height);
    $(element).width(geometry.boxes[index].width);
    $(element).css({
      top: geometry.boxes[index].top,
      left: geometry.boxes[index].left
    });
  });
}
